import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-nueva-vista',
  templateUrl: './nueva-vista.component.html',
  styleUrls: ['./nueva-vista.component.css']
})
export class NuevaVistaComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
